import {
  Box,
  ListItem as MuiListItem,
  Paper as MuiPaper,
  Popper as MuiPopper,
  styled,
} from '@mui/material';

import KlickrentLogo from '@/assets/logo.svg';
import ChipBase from '@/components/ui/Chip/Chip';

export const ImagePlaceholder = styled(KlickrentLogo)(() => ({
  width: 60,
  height: 60,
  opacity: 0.2,
  top: '50%',
  left: '50%',
}));

export const SearchInputWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  background: theme.palette.common.white,
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.grayscale[200]}`,
  [theme.breakpoints.up('md')]: {
    borderBottom: 'none',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: `${theme.shape.borderRadiusLarge}px`,
  },
}));

export const Popper = styled(MuiPopper)(({ theme }) => ({
  display: 'flex',
  width: '100% !important',
  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(1),
  },
}));

export const Paper = styled(MuiPaper)(({ theme }) => ({
  width: '100%',
  borderRadius: 0,
  [theme.breakpoints.up('md')]: {
    borderRadius: `${theme.shape.borderRadiusLarge}px`,
  },
}));

export const Chip = styled(ChipBase)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
  alignSelf: 'flex-start',
}));

export const ListItem = styled(MuiListItem)(({ theme }) => ({
  gap: theme.spacing(2),
}));
